// =============================================
// COMPONENTE: JavaScriptFunctionNode - Nó de Função JavaScript
// =============================================
// Arquivo: JavaScriptFunctionNode.tsx
// Descrição: Nó para executar código JavaScript customizado no fluxo
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Code, FileCode, Database } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const JavaScriptFunctionNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    code,
    inputVariables = [],
    outputVariable,
    description,
    actions
  } = data;

  const getCodePreview = (code: string) => {
    if (!code) return 'Sem código';
    const firstLine = code.split('\n')[0];
    return firstLine.length > 30 ? firstLine.substring(0, 30) + '...' : firstLine;
  };

  return (
    <div className={`flow-node javascript-function-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header javascript-function-header">
        <Code className="node-icon" size={18} />
        <span className="node-title">{label || 'JavaScript Function'}</span>
      </div>

      <div className="node-body">
        {code && (
          <div className="node-detail">
            <FileCode size={14} />
            <span className="node-detail-text code-preview">
              {getCodePreview(code)}
            </span>
          </div>
        )}
        {inputVariables.length > 0 && (
          <div className="node-badge">
            <Database size={12} /> {inputVariables.length} input(s)
          </div>
        )}
        {outputVariable && (
          <div className="node-badge success">
            → {outputVariable}
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default JavaScriptFunctionNode;
